import { render, staticRenderFns } from "./BuyBookModal.vue?vue&type=template&id=b0cc4eb8&scoped=true&"
import script from "./BuyBookModal.vue?vue&type=script&lang=js&"
export * from "./BuyBookModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyBookModal.vue?vue&type=style&index=0&id=b0cc4eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cc4eb8",
  null
  
)

export default component.exports